import React from 'react';

const Permissions = React.createContext(null);

export default Permissions;
